module.exports = __webpack_public_path__ + "static/media/image.30879c38.webp";